/* eslint-disable formatjs/no-literal-string-in-jsx */
'use client';

import { cn } from '@bazaar-marketplace/utils';
import { hapticFeedback } from '@telegram-apps/sdk-react';
import { usePathname, useRouter } from 'next/navigation';
import type { FC, ReactNode } from 'react';

import { Typography } from '~/components';

export interface NavigationItemProps {
  text: string;
  href: string;
  icon: ReactNode;
  disabled: boolean;
  className?: string;
  onClick?: () => void;
}

export const NavigationItem: FC<NavigationItemProps> = ({ href, icon, text, disabled, className, onClick }) => {
  const pathname = usePathname();
  const router = useRouter();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      return;
    }

    if (hapticFeedback.isSupported()) {
      hapticFeedback.impactOccurred('medium');
    }

    if (onClick) {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    } else {
      router.push(href);
    }
  };

  return (
    <button
      className={cn(
        'flex flex-col gap-1 items-center justify-center relative font-bold',
        pathname === href ? 'text-white' : 'text-white/70',
        className,
      )}
      disabled={disabled}
      onClick={onClick || handleClick}
    >
      {disabled ? (
        <div className="absolute right-1.5 top-0 text-[#362D4B] z-20 bg-white w-9 rounded-lg h-4 text-[10px] text-center whitespace-nowrap font-bold">
          Soon
        </div>
      ) : null}
      <div
        className={cn('flex flex-col gap-1 items-center justify-center', disabled && 'opacity-40 pointer-events-none')}
      >
        {icon}
        <Typography className="text-[11px]" size="xss" tag="span" weight="bold">
          {text}
        </Typography>
      </div>
    </button>
  );
};
